/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { createUseStyles } from 'react-jss';

export const useDialogStyles = createUseStyles({
    dialogWithoutContentPadding: {
        '&::part(content)': {
            padding: 0,
        },
    },
});
